import React, { useState } from "react";
import {
  ContactContainer,
  ContactInfo,
  LogoImg,
  ContactFirmName,
  ContactBtnWrapper,
  UpArrow,
  ConAddressH1,
  ConAddressIcon,
  ConAddressIconPlace,
  ConArea1,
  LogoWrapper,
  ConName,
  ConAddress,
  ConEmail,
  ConEmailH1,
  ConEmailIcon,
  ConEmailIconPlace,
  ConPhone,
  ConPhoneH1,
  ConPhoneIcon,
  ConPhoneIconPlace,
  ConArea2,
  ConIcons,
  ConText,
  ConMain,
} from "./ContactElementsEN";
import { Button } from "../ButtonElement";
import Image3 from "../../images/logo.jpg";
import Image from "../../images/maps.png";
import Image1 from "../../images/mail.png";
import Image2 from "../../images/call.png";

const ContactSectionEN = ({ id }) => {
  const [hover, setHover] = useState(false);

  const onHover = () => {
    setHover(!hover);
  };

  return (
    <ContactContainer id={id}>
      <ContactInfo>
        <ConArea1>
          <ConName>
            <LogoWrapper>
              <LogoImg src={Image3} type="image/jpg" />
            </LogoWrapper>
            <ContactFirmName>ETS - Paweł Wróblewski</ContactFirmName>
          </ConName>
          <ConMain>
            <ConIcons>
              <ConAddressIconPlace>
                <ConAddressIcon src={Image} type="image/png" />
              </ConAddressIconPlace>
              <ConEmailIconPlace>
                <ConEmailIcon src={Image1} type="image/png" />
              </ConEmailIconPlace>
              <ConPhoneIconPlace>
                <ConPhoneIcon src={Image2} type="image/png" />
              </ConPhoneIconPlace>
            </ConIcons>
            <ConText>
              <ConAddress>
                <ConAddressH1>
                  ul. Bema 8 <br />
                  Zduńska Wola 98-220
                </ConAddressH1>
              </ConAddress>
              <ConEmail>
                <ConEmailH1> pawel.wroblewski54@gmail.com</ConEmailH1>
              </ConEmail>
              <ConPhone>
                <ConPhoneH1>601 319 021</ConPhoneH1>
              </ConPhone>
            </ConText>
          </ConMain>
          <ContactBtnWrapper>
            <Button
              to="startEN"
              onMouseEnter={onHover}
              onMouseLeave={onHover}
              primary="true"
              dark="true"
              smooth={true}
              duration={500}
              spy={true}
              exact={true}
              offset={-65}
            >
              <UpArrow />
            </Button>
          </ContactBtnWrapper>
        </ConArea1>
        <ConArea2>
          <iframe
            title="maplocation"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2478.741195133902!2d18.96175045140072!3d51.59130647954904!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471a5b60b31f6101%3A0x3a9c74f637351d36!2sBema%208%2C%2098-311%20Zdu%C5%84ska%20Wola!5e0!3m2!1spl!2spl!4v1669183521778!5m2!1spl!2spl"
            height={450}
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </ConArea2>
      </ContactInfo>
    </ContactContainer>
  );
};

export default ContactSectionEN;
